export default __webpack_public_path__ + "static/SubmitterHelp-02944f6685d686fa3b401b578c8250cc.svg";